export default __webpack_public_path__ + "static/media/warning--domestic-animals--g5.59bfd681.png";